import { render } from "./FizikQuest.vue?vue&type=template&id=929c2ed4&scoped=true"
import script from "./FizikQuest.vue?vue&type=script&lang=js"
export * from "./FizikQuest.vue?vue&type=script&lang=js"

import "./FizikQuest.vue?vue&type=style&index=0&id=929c2ed4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-929c2ed4"]])

export default __exports__